
import { computed, defineComponent, PropType } from 'vue';
import { LectureDetail } from '@/apis/lecture/types';

export default defineComponent({
  props: {
    lectureInfo: {
      type: Object as PropType<LectureDetail>,
      required: true,
    },
    loading: { type: Boolean, required: true },
  },
  setup(props) {
    const withdrawable = computed(() => {
      if (props.lectureInfo.detailInfo.withdrawable === 'true' || props.lectureInfo.detailInfo.withdrawable === '是') {
        return '是';
      }
      if (props.lectureInfo.detailInfo.withdrawable === '否' || props.lectureInfo.detailInfo.withdrawable === '') {
        return '否';
      }
      return '未知';
    });
    return {
      withdrawable,
    };
  },
  data() {
    return {
      isAllLectureInfoVisible: false,
    };
  },
});
